import CardHeader from "@/components/CardHeader";
import useAuthStore from "@/store/useAuthStore";
import { CAR_WEIGHT } from "@/utils/constants";
import { parseMoney } from "@/utils/helpers";
import { Button, Card, Divider, Flex, Group, Modal, ScrollArea, Table, Text, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconReceipt, IconTable } from "@tabler/icons-react";
import QueryString from "qs";
import React, { useState, useEffect } from "react";
import useSWR from "swr";

export default function PriceTableModal({ companyId }) {
  const user = useAuthStore((s) => s.user);
  const [opened, { open, close }] = useDisclosure();

  const params = QueryString.stringify({
    filters: {
      company: companyId,
    },
    sort: ["createdAt:asc"],
    pagination: {
      page: 1,
      pageSize: 100,
    },
  });

  const { data } = useSWR(opened ? ["/prices", params] : null);
  const resultList = data?.data?.map((x) => ({ id: x?.id, ...x.attributes }));
  return (
    <>
      <Button size="md" color="violet" onClick={open} disabled={!companyId}>
        단가표
      </Button>

      <Modal opened={opened} onClose={close} title="단가표" size={900}>
        <Card shadow="0">
          <Group mb="sm">
            <Flex gap="sm" align="center">
              <Title order={5}>{`상차지: ${resultList?.[0]?.startAddress || "-"}`}</Title>
            </Flex>
          </Group>

          <Card.Section withBorder>
            <ScrollArea>
              <Table horizontalSpacing="0" verticalSpacing={"xs"}>
                <thead>
                  <tr style={{ backgroundColor: "#b8dfff" }}>
                    <th className="tc">하차지</th>
                    {CAR_WEIGHT.map((item) => {
                      return (
                        <th className="tc" key={item.value}>
                          {item.label}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {resultList?.map((item, idx) => {
                    return (
                      <tr key={item.id}>
                        <td className="tc" style={{ fontWeight: 700 }}>
                          {item.endAddress}
                        </td>
                        {CAR_WEIGHT.map((c) => {
                          const x = resultList.find((x) => x.endAddress === item.endAddress);
                          return (
                            <td className="tc" key={c.value}>
                              {x ? parseMoney(x?.[c.value]) : "-"}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}

                  {/* // FIXED */}
                  <tr style={{ backgroundColor: "#f8f9fa", borderTop: "4px solid #015aa1" }}>
                    <td className="tc">경유비(관내)</td>
                    {CAR_WEIGHT.map((c) => {
                      return (
                        <td className="tc" key={c.value}>
                          {parseMoney(10000 * c.wp)}
                        </td>
                      );
                    })}
                  </tr>

                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    <td className="tc">경유비(관외)</td>
                    <td className="tc" colSpan={12}>
                      실비 협의
                    </td>
                  </tr>

                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                    <td className="tc">윙바디(추가)</td>
                    {CAR_WEIGHT.map((c) => {
                      return (
                        <td className="tc" key={c.value}>
                          {parseMoney(10000 * c.wing)}
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </Table>
            </ScrollArea>
          </Card.Section>
        </Card>

        <Card mt="md" shadow="0">
          <CardHeader title="메모/특이사항" />
          <Text sx={{ whiteSpace: "break-spaces" }}>{user?.company?.contractMemo}</Text>
        </Card>

        <Divider mt={50} size="xl" />

        <Card mt={50} shadow="0">
          <CardHeader title="견적 조건" />
          <Text>- 지게차 상하차 조건</Text>
          <Text>- 카고 기준</Text>
        </Card>
      </Modal>
    </>
  );
}
